/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useEffect } from 'react'
import { DoubleSide } from 'three';
import { useThree } from '@react-three/fiber';

import { textureAnisotropy } from '../../../utils/Functions';
import { const_var } from '../../../redux/reducers/reducer';


const Background = () => {
    const { gl } = useThree();
    
    const textureGrass = const_var.textureGrass;
    textureAnisotropy(gl, textureGrass, 300, 300, 0);
    const textureGray = const_var.textureGray;
    textureAnisotropy(gl, textureGray, 300, 1, 0);

    const SKYIMG = const_var.skyIMG;;
    textureAnisotropy(gl, SKYIMG, 1, 1, 0);

    const GROUNDIMG = const_var.groundIMG;
    textureAnisotropy(gl, GROUNDIMG, 90, 90, 0);
    
    useEffect(() => {
        if(const_var.crmSetting.is_show_background !== undefined && const_var.crmSetting.is_show_background === true) {
            const_var.controls.maxPolarAngle = Math.PI / 2;
            if (const_var.scene) const_var.scene.fog = null;
        } else {
            const_var.controls.maxPolarAngle = Math.PI;
            // if (const_var.scene) const_var.scene.fog = new THREE.Fog( 0xF2F2F2, 350, 2500);
        }
        
        const_var.controls.update();
    }, [const_var.crmSetting.is_show_background, const_var.scene])

    return (
        <>
            {/* {(const_var.crmSetting.is_show_background !== undefined && const_var.crmSetting.is_show_background) &&
                <group>
                    <mesh name='virtual-box' position={[0, -1, 0]} visible={const_var.crmSetting.is_show_background}>
                        <boxGeometry args={[0, 0, 0]} />
                        <meshBasicMaterial map={textureSky} color={'#a0a0a0'} side={DoubleSide} needsUpdate={true} />
                    </mesh>
                    <mesh>
                        <sphereGeometry args={[500, 190, 160]} />
                        <meshBasicMaterial map={textureSky} color={'#a0a0a0'} side={DoubleSide} needsUpdate={true} />
                    </mesh>
                    <mesh rotation={[-Math.PI / 2, 0, 0]}>
                        <planeGeometry args={[5000, 5000, 100, 100]} />
                        <meshBasicMaterial map={textureGrass} color={'#a9a9a9'} needsUpdate={true} />
                    </mesh>
                </group>
            } */}
            {(const_var.crmSetting.is_show_background !== undefined && const_var.crmSetting.is_show_background==false) &&
                <>
                    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,0,0]} name='background white'>
                        <planeGeometry args={[5000, 5000, 100, 100]} />
                        <meshBasicMaterial side={THREE.FrontSide} needsUpdate={true} color={"#b1ff9d"} />
                    </mesh>
                    {/* {const_var.crmSetting.is_show_background && */}
                        <mesh position={[0,10,0]} name='background white'>
                            <sphereGeometry args={[600, 190, 160]}/>
                            <meshStandardMaterial map={textureGray}   side={DoubleSide} needsUpdate={true} roughness={0.9} metalness={0}  emissive={"#b1ff9d"}/>
                        </mesh>
                    {/* } */}
                </>
            }
            {(const_var.crmSetting.is_show_background !== undefined && const_var.crmSetting.is_show_background) &&
                <>
                    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,0,0]} name='background sky'>
                        <planeGeometry args={[window.innerWidth, window.innerHeight, 100, 100]} />
                        <meshBasicMaterial map={GROUNDIMG} side={THREE.FrontSide} needsUpdate={true}  color={"#ABABAB"}/>
                    </mesh>
                    <mesh position={[0,0,0]} name='background sky'>
                        <sphereGeometry args={[600, 190, 160]}/>
                        <meshBasicMaterial map={SKYIMG}   side={DoubleSide} needsUpdate={true} color={"#BFBFBF"}/>
                    </mesh>
                </>
            }
        </>
    )
}

export default Background